export default __webpack_public_path__ + "static/img-3-7819da43893cea917310cabb57382a0e.png";